<ham-modal
    [title]="title"
    [saveText]="saveLabel"
    [showCancelButton]="true"
    [cancelText]="cancelLabel"
    (save)="onSave()"
    (cancel)="onCancel()"
>
    <div class="reclass-modal-scroll-body">
    <div class="reclass-modal-subtitle">
        <span>{{ subtitleSourcePrefix }}: <strong>{{ sourceLabel }}</strong></span>
        <span *ngIf="sourceBalance != null">
            · {{ subtitleBalancePrefix }}: {{ sourceBalance | number : '1.2-2' }}
        </span>
        <span>· {{ isPY ? subtitlePeriodPY : subtitlePeriodCY }}</span>
    </div>

    <!-- Incoming (read-only) -->
    <div class="incoming-section" *ngIf="existingIncoming?.length">
        <div class="section-title">{{ incomingTitle }}</div>
        <div class="incoming-item" *ngFor="let t of existingIncoming">
            <!-- REV-21999: the hard-coded "+" is only correct for a positive leg. A negative
                 incoming reclassification takes value AWAY from this account, and the formatted
                 number already carries its own minus sign — prefixing it unconditionally rendered
                 "+ -5'000.00". -->
            <span class="incoming-amount">{{ t.amount > 0 ? '+ ' : '' }}{{ t.amount | number : '1.2-2' }}</span>
            <span class="incoming-arrow">←</span>
            <span class="incoming-source">{{ displayNumber(t.source.accountNumber) }} {{ t.source.name }}</span>
        </div>
    </div>

    <!-- Outgoing (editable) -->
    <div class="outgoing-section">
        <div class="section-title">{{ outgoingTitle }}</div>

        <div class="reclass-entry" *ngFor="let entry of entries; let i = index; trackBy: trackByUiKey">
            <div class="reclass-entry-header">
                <span class="reclass-entry-index">#{{ i + 1 }}</span>
                <button
                    *ngIf="entries.length > 1 || entry.id"
                    class="reclass-entry-delete"
                    type="button"
                    (click)="onRemoveEntry(i)"
                >
                    {{ deleteLabel }}
                </button>
            </div>

            <div class="reclass-entry-row">
                <div class="form-group amount-group">
                    <label>{{ amountLabel }} <span class="required">*</span></label>
                    <!-- Using ngModel (with standalone:true) because hamInput is a
                         ControlValueAccessor: for type="number" it renders its own
                         display label which is only updated through writeValue() —
                         a plain [value] binding leaves the label blank. -->
                    <input
                        hamInput
                        type="number"
                        step="0.01"
                        [ngModel]="entry.amount"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="onAmountChange(i, $event)"
                        [placeholder]="amountPlaceholder"
                        [class.input-error]="submitAttempted && isAmountInvalid(entry)"
                    />
                    <div class="field-error" *ngIf="submitAttempted && isAmountInvalid(entry)">
                        {{ errAmountRequired }}
                    </div>
                </div>

                <div class="form-group target-group">
                    <label>{{ targetLabel }} <span class="required">*</span></label>
                    <!-- Same reason as the amount input: native <select> with [value]
                         doesn't reliably resolve the selected option when *ngFor renders
                         the options after the [value] binding is evaluated. ngModel
                         resolves the selection correctly once options exist. -->
                    <!-- `title` rather than the hamTooltip directive: the options of a native
                         <select> are rendered by the browser/OS, where only the native tooltip can
                         show. Both are set, so the full label is readable whether the user hovers the
                         closed field or an item in the open list. -->
                    <select
                        class="select"
                        [ngModel]="targetValueOf(entry)"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="onTargetSelect(i, $event)"
                        [class.select-error]="submitAttempted && isTargetInvalid(entry)"
                        [title]="targetLabelOf(entry)"
                    >
                        <option value="">{{ targetPlaceholder }}</option>
                        <!-- REV-21798: ONE flat list — containers (FLI / SubFLI / G&M group) and
                             concrete accounts interleaved in the SAME ORDER the Grouping & Masking
                             table shows them, so the user finds a target where they already see
                             it. Picking a container makes the parent materialize a `MAN` account
                             inside it and reclassify into that. -->
                        <option *ngFor="let opt of availableTargets" [value]="opt.value" [title]="opt.label">
                            {{ opt.label }}
                        </option>
                    </select>
                    <div class="field-error" *ngIf="submitAttempted && isTargetInvalid(entry)">
                        {{ errTargetRequired }}
                    </div>
                </div>

                <div class="form-group action-group">
                    <label>&nbsp;</label>
                    <button
                        class="btn-new-account"
                        type="button"
                        [title]="newAccountLabel"
                        (click)="onCreateNewAccount(i)"
                    >
                        +
                    </button>
                </div>
            </div>

            <div class="field-warn" *ngIf="isDuplicateTarget(entry)">{{ warnDuplicateTarget }}</div>

            <div class="form-group description-group">
                <label>
                    {{ descriptionLabel }}
                    <span class="hint">({{ descriptionOptionalHint }})</span>
                </label>
                <input
                    hamInput
                    [ngModel]="entry.description"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onDescriptionChange(i, $event)"
                    [placeholder]="descriptionPlaceholder"
                />
            </div>
        </div>

        <div class="field-warn full-width" *ngIf="exceedsBalance">{{ warnExceedsBalance }}</div>

        <button class="btn-add-entry" type="button" (click)="onAddEntry()">+ {{ addEntryLabel }}</button>
    </div>
    </div><!-- /.reclass-modal-scroll-body -->
</ham-modal>
